// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /marketing/acoes/get/{id}. */
import type { AcoesMarketing_AcaoRow } from './AcoesMarketing_AcaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AcoesMarketing_GetResponseDados {
acao: AcoesMarketing_AcaoRow
}

export type AcoesMarketing_GetResponse = ApiResponse<AcoesMarketing_GetResponseDados>;

registerResponseContract('AcoesMarketing_GetResponse', {
  acao: {
    type: 'object',
    required: true,
    fields: {
      acao_id:          { type: 'number',  required: true },
      acao_franquia_id: { type: 'number',  required: true },
      acao_data:        { type: 'string',  required: true },
      acao_nome:        { type: 'string',  required: true },
      acao_tipo:        { type: 'string',  required: true },
      acao_link:        { type: 'string',  required: false },
      acao_descricao:   { type: 'string',  required: false },
      galeria: {
        type: 'array',
        required: false,
        items: {
          foto_url: { type: 'string',  required: true },
          foto_alt: { type: 'string',  required: false },
        },
      },
      arquivada_em:     { type: 'string',  required: false },
      created_at:       { type: 'string',  required: false },
      updated_at:       { type: 'string',  required: false },
      updated_by:       { type: 'string',  required: false },
    },
  },
})
